import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IdentityService } from './services/identity.service';

@Component({
  selector: 'app-identity',
  templateUrl: './identity.component.html',
  providers: [IdentityService]
})
export class IdentityComponent implements OnInit {

  step: string;
  userguid: string;

  constructor(private _route: ActivatedRoute, private _router: Router, private identitySrv: IdentityService) { }

  ngOnInit() {

    this.step = this._route.snapshot.paramMap.get("step");
    this.userguid = this._route.snapshot.paramMap.get("userguid");

    this.identitySrv.update(this.userguid);

    this.identitySrv.setUserGuid().subscribe(resp => {

      if (resp) {

        if (this.step != null) {
          const step = this.step.split('');
          this._router.navigate([`/employment101/guide/${step[0]}/${step[1]}/${step[2]}/${step[3]}`]);
        } else {
          this._router.navigate([`/employment101`]);
        }

      } else {
        alert("An error occured fetching information about the user please try again!");
        this._router.navigate([`/profile`]);
      }

    });

  }

}
